<template>
    <div class="normalOrder">
        <el-table class="o-table" :data="tableData" :show-header="false">
            <el-table-column>
                <template slot-scope="scope">
                    <el-row class="title-row" type="flex">
                        <el-col :span="6">
                            <span>下单时间：</span><span>{{scope.row.orderTime}}</span>
                        </el-col>
                        <el-col :span="6">
                            <span>订单编号：</span><span>{{scope.row.appNo}}</span>
                        </el-col>
                        <el-col :span="6">
                            <span>订单状态：</span><span>{{formatStatus(scope.row.orderStatus)}}</span>
                        </el-col>
                        <el-col :span="6">
                            <div><el-button type="text" size="small" @click="showDetail(scope.row)">查看详情</el-button></div>
                        </el-col>
                    </el-row>
                    <el-row v-for="item in scope.row.details" class="body-row" :gutter="2" type="flex">
                        <el-col :span="12">
                            <div class="tab-sku-col">
                                <div class="sku-img">
                                    <img :src="item.picUrl" style="width: 100px;height: 100px;object-fit: contain">
                                </div>
                                <div class="sku-attr">
                                    <el-row class="sku-title" @click="showNormal(item)">{{item.prodTitle}}</el-row>
                                    <el-row style="margin-top: 5px">
                                        <template v-for="(name,index) in item.properName.split(':')">
                                            <span>{{name}}:{{item.properVal.split(':')[index]}}</span>
                                        </template>
                                    </el-row>
                                </div>
                            </div>
                        </el-col>
                        <el-col :span="4">
                            <span>数量：</span><span>{{item.num}}</span>
                        </el-col>
                        <el-col :span="4">
                            <span>单价：¥</span><span>{{item.price}}</span>
                        </el-col>
                        <el-col :span="4">
                            <span>小计：¥</span><span>{{subtotal(item.num,item.price)}}</span>
                        </el-col>
                    </el-row>
                    <el-row class="bottom-row" style="border-radius: 0 0 3px 3px">
                        <el-col>
                            <div>合计：</div><div class="total-price">¥{{getTotal(scope.row.details)}}</div>
                        </el-col>
                    </el-row>
                </template>
            </el-table-column>
        </el-table>
        <pagination
                v-show="total>0"
                :total="total"
                :page.sync="params.pageNum"
                :limit.sync="params.pageSize"
                @pagination="loadData"
        />
    </div>
</template>

<script>
    import * as math from "mathjs"
    import {listOrder} from '@/api/business/orderManage'
    import {mapGetters} from 'vuex'
    export default {
        name: "normalOrder",
        props:{
            params:{
                type:Object,
                default:{
                    pageSize:30,
                    pageNum:1,
                    orderStatus:'',//订单状态
                    orderNum:undefined,//订单编号
                    prodTitle:undefined,//产品名称
                    pOpeNo:undefined,//商家账号
                    createTime:undefined,//订单创建时间
                }
            },
            normalStateList:{
                type: Array,
                default: []
            }
        },
        data(){
          return{
              total:0,
              tableData:[]
          }
        },
        created(){
            this.loadData();
        },
        computed:{
            ...mapGetters(['nginx']),

        },
        methods:{
            loadData(){
                let params = JSON.parse(JSON.stringify(this.params));
                params.selfType = '02';//订单商品类别（01-定制商品；02-优选商品）
                listOrder(params).then((re) => {
                    this.tableData = re.rows;
                    this.total = re.total;
                });
            },
            showDetail(row){
                this.$router.push({path:'/custom/myOrder/detail', query: row});
            },
            formatStatus(val){
                // this.normalStateList
                // console.log(val)
            },

            subtotal(num,price){
                let c = math.multiply(math.bignumber(num),math.bignumber(price));
                return math.number(c).toFixed(2);
            },
            getTotal(arr){
                let total = math.number(0);
                arr.forEach(item =>{
                    const c = math.multiply(math.bignumber(item.num),math.bignumber(item.price));
                    // total += math.number(math.chain(total).add(c).done());
                    total = math.add(total,c);
                });
                return math.number(total).toFixed(2);
            },
            showNormal(data){
                console.log(data);
                let routeUrl = this.$router.resolve({path:'/custom/normal/single',query:{pId:data.pId}});
                window.open(routeUrl.href, '_blank');
            }
        }
    }
</script>

<style scoped>
    .normalOrder >>>.el-table .cell,
    .normalOrder >>>.el-table--border td:first-child .cell,
    .normalOrder >>>.el-table--border th:first-child .cell {
        padding-left: 0 !important;
    }
    .normalOrder >>>.el-table .cell{
        padding-right: 0 !important;
    }
    .normalOrder >>>.el-table td {
        padding: 0 !important;
        padding-bottom: 25px !important;
    }
    .normalOrder >>>.el-table tbody tr:hover>td {
        background-color:#ffffff!important
    }

    .customOrder >>>.p-order .o-table .body-row .el-col:not(:last-child) {
        border-right: 0 solid #ccc;
    }

</style>
